var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.options),expression:"options"}],staticClass:"observe-container"},[(_vm.loading)?_c('loading-circle',{attrs:{"color":"rgba(0,0,0,0.36)"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }